import { useDeleteTransactionsMultiple } from '@api/hooks/useDeleteTransactionsMultiple';
import { ConfirmModal } from '@components/ConfirmModal';
import { useTranslation } from 'react-i18next';

interface DeleteTransactionProps {
	id: string;
	fileName: string;
	disabled?: boolean;
}

export const DeleteTransaction = ({ id, fileName, disabled }: DeleteTransactionProps) => {
	const deleteMultiple = useDeleteTransactionsMultiple();
	const { t } = useTranslation('', { keyPrefix: 'payments.batch.modal' });

	const handleDeleteTransaction = async () => {
		await deleteMultiple.mutateAsync({
			transactionIds: [id],
		});
	};

	return (
		<ConfirmModal
			cancelKey={t('cancel')}
			disabled={disabled}
			id={id}
			onRemove={handleDeleteTransaction}
			submitKey={t('accept')}
			titleKey={t('description', { transactionName: fileName })}
		/>
	);
};
